import React from 'react';
import { Box } from '@mui/material';
import { RuleAttributes } from '@loyalty/shared-common/rule-api-client';

export function RuleLabel({ rule }: { rule: RuleAttributes }) {
  return (
    <Box display="flex" alignItems="center">
      <Box fontWeight="bold" mr={1} display="inline" component="span">
        {(rule.position || 0) + 1}.
      </Box>
      <Box display="flex" alignItems="center" flex={1} role="button">
        {rule.name}
      </Box>
    </Box>
  );
}
